import React from "react";
import { withRouter } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Footer from "../common/Footer";

// estilos
import { Text } from "../common/styled";
import "./style.css";
import SliderClients from "./components/SliderClients";
import SliderClientsInfra from "./components/SliderClientsInfra";
import mediaQuery from "../common/mediaQuery";

const Body = ({ routeChange, text, imagens, settings, language }) => {
  const { small } = mediaQuery();

  return (
    <div className="Body-wrapper">
      <Grid
        container
        justify="center"
        alignItems="center"
        alignContent="center"
        className="Body-sectionCliente2"
      >
        <Grid
          item
          xs={7}
          sm={8}
          style={{ display: "inline", marginTop: small ? "15vh" : "5vh" }}
        >
          <Text
            size={small ? "2.5vh" : "6vh"}
            transform="uppercase"
            weight="400"
            style={{
              borderBottom: "solid",
              borderWidth: 3,
              borderColor: "#58b711",
              paddingBottom: 2,
              marginBottom: "3vh"
            }}
            align="center"
            color="#222"
          >
            {text.getTextoClients()[0]}
          </Text>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          style={{
            display: "inline",
            marginBottom: "3vh",
            marginLeft: -10,
            marginRight: -10
          }}
        >
          <SliderClients text={text} language={language} />
        </Grid>

        <Grid
          item
          xs={7}
          sm={8}
          style={{ display: "inline", marginTop: "10vh" }}
        >
          <Text
            size={small ? "2.5vh" : "6vh"}
            transform="uppercase"
            weight="400"
            style={{
              borderBottom: "solid",
              borderWidth: 3,
              borderColor: "#58b711",
              paddingBottom: 2,
              marginBottom: "3vh"
            }}
            align="center"
            color="#222"
          >
            {text.getTextoClients()[1]}
          </Text>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          style={{
            display: "inline",
            marginBottom: "3vh",
            marginLeft: -10,
            marginRight: -10
          }}
        >
          <SliderClientsInfra text={text} language={language} />
        </Grid>
      </Grid>

      <Footer text={text} language={language} />
    </div>
  );
};

export default withRouter(Body);
